<template>
  <q-menu
    ref="ICMMenu-root"
    :model-value="showing"
    :transition-duration="0"
    @update:model-value="newVal => (openMenu !== undefined ? $emit('update:openMenu', newVal) : (showing = newVal))"
    v-bind="$attrs"
    :offset="offset"
    :self="self"
    :anchor="anchor"
    class="q-menu-box"
  >
    <div
      v-if="$slots.header"
      class="ICMMenu-root--header gordita-500-14-m"
    >
      <slot name="header">
        {{ headerText }}
      </slot>
    </div>

    <q-list
      :class="`${rootClass} q-ma-sm`"
      dense
    >
      <slot :bind="{ self, anchor, active, contextMenu, activeClass, rootClass, hoverMode, activeIds: [id] }" />
    </q-list>
  </q-menu>
</template>

<script>
import { ICMEventHub } from './utils';

export default {
  name: 'ICMMenu',
  props: {
    activeClass: {
      type: String,
      default: '',
    },
    rootClass: {
      type: String,
      default: '',
    },
    offset: {
      type: Array,
      default: () => [8, -10],
    },
    self: {
      type: String,
      default: 'top left',
    },
    anchor: {
      type: String,
      default: 'bottom left',
    },
    openMenu: {
      type: Boolean,
      default: () => undefined,
    },
  },
  emits: ['update:openMenu', 'openMenu'],
  data() {
    return {
      id: null,
      active: new Set(),
      submenuMouseoverCounter: 0,
      showing: false,
    };
  },
  computed: {
    contextMenu() {
      return this.$attrs['context-menu'] !== undefined && this.$attrs['context-menu'] !== false;
    },
    hoverMode() {
      return this.$attrs['hover-mode'] !== undefined && this.$attrs['hover-mode'] !== false;
    },
  },
  watch: {
    showing(newValue) {
      this.$emit('openMenu', newValue);
      this.$emit('update:openMenu', newValue);
    },
    openMenu(newValue) {
      if (newValue !== this.showing) this.showing = newValue;
    },
  },
  created() {
    ICMEventHub.$on('submenuMouseleave', () => (this.hoverMode ? this.submenuMouseoverCounter++ : null));
    ICMEventHub.$on('submenuMouseover', activeIds => (this.hoverMode && this.$refs ? this.submenuMouseover(activeIds) : null));
    ICMEventHub.$on('submenuClick', activeIds => (!this.hoverMode && this.$refs ? this.submenuMouseover(activeIds, 0) : null));
    ICMEventHub.$on('itemClick', this.itemClick);
    this.id = ICMEventHub.getId();
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    show() {
      this.$refs['ICMMenu-root'].show();
    },
    // eslint-disable-next-line vue/no-unused-properties
    hide() {
      this.$refs['ICMMenu-root'].hide();
    },
    itemClick(ref, autoClose) {
      if (!ref || !this.$refs['ICMMenu-root']) return;
      if (autoClose) this.$refs['ICMMenu-root'].hide();
    },
    submenuMouseover(activeIds, timeout = 500) {
      if (activeIds?.includes(this.id)) {
        this.submenuMouseoverCounter++;
        const clonedSubmenuMouseoverCounter = this.submenuMouseoverCounter;
        setTimeout(() => {
          if (clonedSubmenuMouseoverCounter === this.submenuMouseoverCounter) {
            if (activeIds) this.active = new Set(activeIds);
          }
        }, timeout);
      }
    },
  },
};
</script>

<style lang="scss">
.ICMMenu-q-item {
  border-radius: 2px;
  padding: 0 8px !important;
  height: 32px;
}
.q-menu-box {
  box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
}
.ICMMenu-root--header {
  height: 40px;
  padding: 11px 16px;
  border-bottom: 2px solid $-system-app-border;
  color: $-text-text-high;
}
</style>
